import { forwardRef } from 'react';
import { Wrapper } from './styled-components';
import { Header } from './header';

type Props = {
  header: React.ReactNode;
  content: React.ReactNode;
  children?: (props: ChildrenProps) => React.ReactNode;
};

type ChildrenProps = Pick<Props, 'header' | 'content'> & {
  ref: React.ForwardedRef<HTMLElement>;
};

export const Section = forwardRef<HTMLElement, Props>(({ header, content, children }, ref) =>
  children ? (
    children({ ref, header, content })
  ) : (
    <Wrapper ref={ref} $as="section">
      {header}
      {content}
    </Wrapper>
  ),
) as unknown as SectionComponent;

type SectionComponent = {
  (props: Props & { ref?: React.ForwardedRef<HTMLElement> }): JSX.Element;
  Header: typeof Header;
  Wrapper: typeof Wrapper;
};

Section.Header = Header;
Section.Wrapper = Wrapper;
